import React from 'react';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PercentChooser = ({
  value,
  min,
  max,
  decreaseIcon,
  increaseIcon,
  onIncrease,
  onDecrease,
  ariaLabelDecreaseButton,
  ariaLabelIncreaseButton,
  ariaDescriptionCurrentValue,
  ariaDescriptionCurrentValueHiddenDiv,
}) => {
  return (
    <Box border={2} display="flex" flexDirection="row" style={{ width: '125px', borderRadius: '10px', position: 'relative' }}>
      <Button
        onClick={onDecrease}
        style={{ minWidth: '10px', width: '30px' }}
        aria-label={ariaLabelDecreaseButton}
        disabled={value === min}
      >
        <FontAwesomeIcon icon={decreaseIcon} />
      </Button>
      <input
        id="percent-chooser-value"
        type="text"
        readOnly
        value={`${value}%`}
        aria-label={ariaDescriptionCurrentValue}
        style={{
          minWidth: '65px',
          padding: '3px 10px 0px 6px',
          textAlign: 'center',
          borderLeft: '2px solid',
          borderRight: '2px solid',
          borderTop: 'none',
          borderBottom: 'none',
          borderRadius: 0,
          background: 'transparent',
          fontSize: 'inherit',
        }}
        tabIndex={0}
      />
      <span
        style={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          margin: '-1px',
          padding: 0,
          overflow: 'hidden',
          clip: 'rect(0 0 0 0)',
          border: 0,
        }}
        role="status"
      >{ariaDescriptionCurrentValueHiddenDiv}</span>
      <Button
        onClick={onIncrease}
        style={{ minWidth: '10px', width: '30px' }}
        aria-label={ariaLabelIncreaseButton}
        disabled={value === max}
      >
        <FontAwesomeIcon icon={increaseIcon} />
      </Button>
    </Box>
  );
};

export default PercentChooser;